import {Description} from "../../components/ProductPageComponents/Description/Description";
import {WhatIsData} from "../../components/ProductPageComponents/WhatIsData/WhatIsData";
import {ContactLink} from "../../components/CummonComponents/ContactLink/ContactLink";
import {PageSubTitle} from "../../components/CummonComponents/PageSubTitle/PageSubTitle";
import {PageTitle} from "../../components/CummonComponents/PageTitle/PageTitle";
import {useProducts, useImageUrl} from "../../queries";
import {Loading} from "../../components/CommonComponents/Loading/Loading";
import {Helmet} from "react-helmet-async";
import {APP_NAME} from "../../utils/constants";


export const Products = () => {
    const {data, isLoading} = useProducts();
    const headerImageUrl = useImageUrl(data?.header_background);

    return (
        <>
            <Helmet>
                <title>Products | {APP_NAME}</title>
            </Helmet>
            {isLoading ? (
                <Loading/>
            ) : !data ? (
                null
            ) : (
                <>
                    <PageSubTitle>
                        {data?.title}
                    </PageSubTitle>
                    <PageTitle image={headerImageUrl}>
                        {data?.header_title}
                    </PageTitle>
                    <WhatIsData data={data}/>
                    <Description data={data}/>
                    <ContactLink
                        titleText={data?.footer_text}
                        btnText={data?.footer_button_text}
                        href={data?.footer_button_href}
                    />
                </>
            )}
        </>
    )
}
